<template>
  <a-modal title="添加兑换码"
           :open="modal"
           :confirm-loading="loading"
           :destroy-on-close="true"
           cancel-text="关闭" @cancel="cancelCk">
    <a-form ref="form"
            size="small"
            :rules="rules"
            :model="entity"
            :label-col="{ span: 4 }"
            :wrapper-col="{ span: 20 }">
      <a-form-item label="兑换码" name="code">
        <a-input v-model:value="entity.code"/>
      </a-form-item>

    </a-form>
    <template #footer>
      <a-button type="primary" @click="okCk">添加</a-button>
    </template>
  </a-modal>
</template>

<script setup>
import {ref} from 'vue'
import axios from '@/axios'

const emits = defineEmits(['refresh'])

const modal = ref(false)
const loading = ref(false)

const form = ref(null)

const entity = ref({
  code: '',
})

const rules = {
  code: [{
    required: true,
    message: '兑换码不能为空',
    trigger: 'blur'
  }, {
    min: 14,
    message: '兑换码最短为14位',
    trigger: 'blur'
  }],
}

function okCk() {
  loading.value = true

  form.value.validate().then(() => {
    axios.post('/act', entity.value).then((res) => {
      if (res.code === 1) {
        emits('refresh')
        modal.value = false
      }
    })
  }).catch(() => {
    loading.value = false
  })
}

function openCk() {
  modal.value = true
}

function cancelCk() {
  modal.value = false
}

defineExpose({openCk})
</script>